// extracted by mini-css-extract-plugin
export default {"badge":"MessageCenterLink_badge__w031n"};